module.exports = __webpack_public_path__ + "images/sprites/ui/btn_tel_cv_time_73933398fbed13d0816b84597be53491.png";